import React from "react";
import { formatMessage } from "lib/globalize-util";
import { PromptDialog } from "@nuorder/components";

interface IOwnProps {
    open: boolean;
    onConfirm: (value: string, callback?: () => void) => void;
    onClose: () => void;
    isLoading: boolean;
    disableConfirm?: boolean;
    errorMessage: string;
}

export const CreateFolderDialog: React.FunctionComponent<IOwnProps> = React.memo(function CreateFolderDialog({
    open,
    onConfirm,
    onClose,
    errorMessage,
    isLoading,
    disableConfirm,
}) {
    const [disabled, setDisabled] = React.useState<boolean>(true);
    const handlePromptTextChange = React.useCallback((value) => {
        // TODO: can add error message
        setDisabled(!value?.trim());
    }, []);

    return (
        <PromptDialog
            title={formatMessage("New Folder")}
            confirmLabel={formatMessage("Name:")}
            open={open}
            onConfirm={onConfirm}
            onPromptTextChange={handlePromptTextChange}
            onClose={onClose}
            errorMessage={errorMessage}
            confirmButtonDisabled={disabled || disableConfirm}
            isLoading={isLoading}
            customTextForSave={formatMessage("Create")}
            customTextForCancel={formatMessage("Cancel")}
            closeButtonAriaLabel={formatMessage("Close")}
            blankErrorMessage={formatMessage("You can't leave this blank.")}
        />
    );
});
